import styled, { css } from "styled-components";
import { fontBold } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

export const TopPoolsWrapper = styled.section`
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "100")};
  ${({ showHeader }) =>
    showHeader &&
    css`
      border-top: 1px solid ${buildColor("grey", "L2")};
      border-bottom: 1px solid ${buildColor("grey", "L2")};
    `}
`;

export const Title = styled.h1`
  color: ${buildColor("grey", "D4")};
  font-size: 16px;
  font-family: ${fontBold};
  font-weight: 500;
  text-transform: capitalize;
  margin-bottom: 12px;
  letter-spacing: 0;
  padding: 12px 16px;
  border-bottom: 1px solid ${buildColor("grey", "L2")};
`;

export const TopPoolsContainer = styled.div`
  display: flex;
  width: 100%;
  overflow: auto;
  overflow-x: scroll;
  padding-bottom: 12px;
`;
